import { cn } from "@/lib/utils";

const TEMPERATURE_CONFIG = {
  chaud: {
    label: "Chaud",
    dot: "bg-fabrik-red",
    bg: "bg-fabrik-red-soft text-fabrik-red",
  },
  a_chauffer: {
    label: "À chauffer",
    dot: "bg-fabrik-orange",
    bg: "bg-fabrik-orange-soft text-fabrik-orange",
  },
  froid: {
    label: "Froid",
    dot: "bg-fabrik-blue",
    bg: "bg-fabrik-blue-soft text-fabrik-blue",
  },
  perdu: {
    label: "Perdu",
    dot: "bg-fabrik-text-3",
    bg: "bg-fabrik-gray-pill text-fabrik-text-2",
  },
} as const;

export type Temperature = keyof typeof TEMPERATURE_CONFIG;

export function TemperaturePill({
  temperature,
  className,
}: {
  temperature: Temperature | null | undefined;
  className?: string;
}) {
  if (!temperature) return null;
  const config = TEMPERATURE_CONFIG[temperature];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-fabrik-pill px-2 py-0.5 text-xs font-medium",
        config.bg,
        className,
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", config.dot)} />
      {config.label}
    </span>
  );
}
